
import { defineComponent, PropType, onMounted, computed } from 'vue';
import BreadcrumbComponent from '@/components/general/Breadcrumb.vue';
import { Breadcrumb } from '@/types/Global';
import { useStore } from '@/store';

import { getters as generalGetters } from '@/store/modules/general/getters';
import { GeneralActionTypes } from '@/store/modules/general/action-types';

export default defineComponent({
  name: 'Header',
  components: {
    BreadcrumbComponent,
  },
  props: {
    breadcrumbItems: {
      type: Array as PropType<Array<Breadcrumb>>,
      default: [] as Array<Breadcrumb>,
    },
    translationKey: {
      type: String,
      default: '',
    },
    translationParams: {
      type: Object,
      default: null,
    },
    hideDataUpdate: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useStore();

    const getEtlUpdateDate = computed(() => {
      return generalGetters.getEtlUpdateDate(store.state.general);
    });

    const getEtlInfo = () => {
      store.dispatch(GeneralActionTypes.GET_ETL_DATA, undefined);
    };

    const getUserPreferencesFromState = computed(() => {
      return generalGetters.getUserPreferences(store.state.general);
    });

    const getUserPreferencesFromApi = () => {
      store.dispatch(GeneralActionTypes.GET_USER_PREFERENCES, undefined);
    };

    const toggleViewHistoric = async (nextToggleValue: boolean) => {
      await store.dispatch(
        GeneralActionTypes.SET_USER_PREFERENCES,
        nextToggleValue
      );
    };

    onMounted(() => {
      getEtlInfo();
      getUserPreferencesFromApi();
    });

    return {
      getEtlUpdateDate,
      toggleViewHistoric,
      getUserPreferencesFromState,
    };
  },
});
